<template>
  <div class="app-canada-post-fallback">
    <div>
      <AppInput
        label="Street Address"
        name="app-input__street-address"
        :error="streetAddressError"
        :value="streetAddress"
        v-data-layer
        :data-layer="dataLayerStreet"
        @input="handleInput('street_address', $event)"
      />
    </div>

    <div class="app-canada-post-fallback__row">
      <AppInput
        label="City"
        name="app-input__city"
        :value="city"
        :error="cityError"
        v-data-layer
        :data-layer="dataLayerCity"
        @input="handleInput('city', $event)"
      />
      <AppSelect
        label="Province or Territory"
        name="app-input__province"
        class="app-canada-post-fallback__row__province"
        :value="province"
        :error="provinceError"
        :options="provinces"
        v-data-layer
        :data-layer="dataLayerProvince"
        @input="handleInput('province', $event)"
      />
      <AppInput
        label="Postal Code"
        name="app-input__postal-code"
        :value="postalCode"
        :error="postalCodeError"
        v-data-layer
        :data-layer="dataLayerPostal"
        @input="handleInput('postal_code', $event)"
      />
    </div>
  </div>
</template>

<script>
import AppInput from '../inputs/AppInput'
import AppSelect from '../inputs/AppSelect'
import validation from '@/mixins/validation'

export default {
  // Name
  name: 'app-canada-post-fallback',

  // Components
  components: {
    AppInput,
    AppSelect
  },

  mixins: [validation],
  // Props
  props: {
    dataLayerStreet: String,
    dataLayerCity: String,
    dataLayerProvince: String,
    dataLayerPostal: String
  },

  // Data
  data () {
    return {
      submitted: false,
      provinces: [
        // 'Province or Territory'
        'AB',
        'BC',
        'MB',
        'NB',
        'NL',
        'NT',
        'NS',
        'NU',
        'ON',
        'PE',
        'QC',
        'SK',
        'YT'
      ],
      errorMessages: {
        isRequired: 'This field is required.',
        isPostalCode: 'Enter a valid postal code.'
      }
    }
  },

  // Computed
  computed: {
    streetAddress () {
      return this.$store.state.application.street_address
    },

    streetAddressError () {
      if (!this.submitted) return ''
      if (!this.streetAddress) return this.errorMessages.isRequired
      if (this.streetAddress.length > 100) return this.getMaxLengthErrorMessage(100)
    },

    city () {
      return this.$store.state.application.city
    },

    cityError () {
      if (!this.submitted) return ''
      if (!this.city) return this.errorMessages.isRequired
      if (this.city.length > 40) return this.getMaxLengthErrorMessage(40)
    },

    province () {
      return this.$store.state.application.province
    },

    provinceError () {
      if (!this.submitted) return ''
      if (!this.province) return this.errorMessages.isRequired
    },

    postalCode () {
      return this.$store.state.application.postal_code
    },

    postalCodeError () {
      if (!this.submitted) return ''
      if (!this.postalCode) return this.errorMessages.isRequired
      if (!this.isValidPostalCode) return this.errorMessages.isPostalCode
    },

    isValidPostalCode () {
      return (/^[a-zA-Z][0-9][a-zA-Z](-| |)[0-9][a-zA-Z][0-9]$/).test(this.postalCode.trim())
    },

    fallbackIsValid () {
      return !this.provinceError &&
        !this.streetAddressError &&
        !this.cityError &&
        !this.postalCodeError
    }
  },

  // Mounted
  mounted () {
    this.$bus.$on('validate-fallback', () => {
      this.validateFallback()
    })
  },

  // Methods
  methods: {
    handleInput (field, value) {
      this.$store.updateApplication(field, value)
    },

    async validateFallback () {
      this.submitted = true
      try {
        if (this.fallbackIsValid) {
          this.$emit('fallback-validated')
        }
      } catch (error) {
        console.warn(error)
        this.$emit('fallback-error')
      }
    }
  }
}
</script>

<style lang="scss">
.app-canada-post-fallback {
  &__row {
    @include breakpoint('tablet-landscape-up') {
      display: flex;
    }
    .app-select__error {
      position: absolute;
      top: auto;
      right: 0;
      bottom: -21px;
      left: auto;
      font-size: 12px;
      @include breakpoint('tablet-portrait-up') {
        font-size: 14px;
        top: -28px;
        right: auto;
        bottom: auto;
      }
    }
    &__province.app-select, &__province.has-error {
      margin-bottom: 22px;
      @include breakpoint('tablet-portrait-up') {
        margin-bottom: 40px;
      }
    }
  }
}
</style>
